var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import uniqueId from 'lodash/uniqueId';
import PdpHeaderShopify from './pdpHeaderShopify';
var PdpHeader = /** @class */ (function (_super) {
    __extends(PdpHeader, _super);
    function PdpHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.getPlantSize = function (data) {
            var height;
            var width;
            if (data.plant_size) {
                if (data.plant_size.height) {
                    height = (React.createElement("li", null,
                        "H:",
                        ' ',
                        data.plant_size.height));
                }
                if (data.plant_size.width) {
                    width = (React.createElement("li", null,
                        "W:",
                        ' ',
                        data.plant_size.width));
                }
                return (React.createElement("ul", { className: "pdp_details__list pdp_details__list-size" },
                    height,
                    width));
            }
            return null;
        };
        _this.getZones = function (data) {
            if (data.zones) {
                var zones = data.zones;
                return (React.createElement("ul", { className: "pdp_details__list pdp_details__list-zones" },
                    React.createElement("li", null, zones)));
            }
            return null;
        };
        return _this;
    }
    PdpHeader.prototype.render = function () {
        var _a = this.props, photos = _a.photos, addToShopifyCart = _a.addToShopifyCart, shopifyVariants = _a.shopifyVariants, partnersData = _a.partnersData, alias = _a.alias, title = _a.title, scientificName = _a.scientificName, djangoPk = _a.djangoPk, affiliatedLinks = _a.affiliatedLinks, plantData = _a.plantData, isForSale = _a.isForSale;
        var headerClass = 'pdp_header';
        var aliases = null;
        var scientificNameEl = null;
        var buyBtn = null;
        var photo = photos.length > 0 ? photos[0] : null;
        headerClass += isForSale ? ' isForSale' : '';
        buyBtn = (React.createElement(PdpHeaderShopify, { djangoPk: djangoPk, onAddToShopifyCart: addToShopifyCart, variants: shopifyVariants.filter(function (item) { return item.available; }), title: title, partnersData: partnersData, isForSale: isForSale, affiliatedLinks: affiliatedLinks }));
        if (alias && alias.length > 0) {
            var allAliases = alias.map(function (item) { return React.createElement("li", { key: uniqueId(item) }, item); });
            aliases = (React.createElement("div", { className: "pdp_header__aliases_container" },
                React.createElement("h3", null, "Also Known As"),
                React.createElement("ul", { className: "pdp_header__aliases" }, allAliases)));
        }
        if (scientificName !== null) {
            scientificNameEl = (React.createElement("p", { className: "pdp_header__scientific_name" },
                "Scientific Name:",
                ' ',
                scientificName));
        }
        var photoContributorName = null;
        if (photo) {
            photoContributorName = (React.createElement("span", { className: "carousal_attr_title" }, photo.contributor_info.name ? photo.contributor_info.name : 'Unknown'));
            if (photo.contributor_info.is_nursery && photo.contributor_info.active) {
                var nurseryLink = "/nurseries/".concat(encodeURIComponent(photo.contributor_info.slug), "/");
                photoContributorName = (React.createElement("a", { href: nurseryLink, rel: "noopener noreferrer" },
                    React.createElement("span", { className: "carousal_attr_title link" }, photo.contributor_info.name ? photo.contributor_info.name : 'Unknown')));
            }
        }
        return (React.createElement("header", { className: headerClass },
            React.createElement("div", { className: "pdp_header__images" }, photo ? (React.createElement("div", { className: "pdp_header__image" },
                React.createElement("div", { className: "submission_pres" },
                    React.createElement("a", { href: "#photo-gallery" },
                        React.createElement("picture", null,
                            React.createElement("source", { type: "image/webp", srcSet: photo.photo_webp }),
                            React.createElement("source", { type: "image/jpeg", srcSet: photo.photo }),
                            React.createElement("img", { src: photo.photo, alt: photo.alt })))),
                React.createElement("div", { className: "submission_text no_min_height", style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '10px',
                    } },
                    React.createElement("div", { className: "attribution" },
                        React.createElement("p", null,
                            React.createElement("span", { className: "carousal_attr" }, "Photo by "),
                            photoContributorName),
                        React.createElement("p", { className: "small" }, photo.copyright_info)),
                    React.createElement("a", { href: "#photo-gallery", className: "btn neutral show_all_photos" }, "Show all photos")))) : (React.createElement("div", { className: "pdp_header__no-image" },
                React.createElement("img", { src: "".concat(process.env.STATIC_PATH, "/img/placeholder_plant_photo.svg"), alt: "Placeholder" })))),
            React.createElement("div", { style: title ? { minHeight: 60 } : { minHeight: 130 }, className: "pdp_header__text" },
                React.createElement("h1", null,
                    isForSale ? 'Buy ' : '',
                    title),
                scientificNameEl,
                aliases),
            React.createElement("div", { className: "pdp_header__detail" },
                React.createElement("div", { className: "pdp_details__1" },
                    React.createElement("div", { className: "column plant_type" },
                        React.createElement("h3", { className: "pdp_plant__type" }, "Plant type"),
                        React.createElement("p", { className: "pdp_details__list pdp_details__list-type" }, plantData.get_plant_types.join(', '))),
                    React.createElement("div", { className: "column size" },
                        React.createElement("h3", { className: "pdp_plant__size" }, "size"),
                        this.getPlantSize(plantData)),
                    React.createElement("div", { className: "column zone" },
                        React.createElement("h3", { className: "pdp_plant__zone" }, "planting zones"),
                        this.getZones(plantData))),
                buyBtn)));
    };
    return PdpHeader;
}(React.Component));
export default PdpHeader;
